export default class BaseDeclaration {
  public declaration = '';

  protected generateInvalidError(declarationString: string, valueString: string, message: string) {
    return {
      phase: 'GenerateToken',
      code: 'invalid-declaration',
      declaration: this.declaration,
      valueString,
      declarationString,
      message
    };
  }

}

// tslint:disable-next-line
export interface DeclarationFactory {

  declaration: string;

  /**
   * 该方法是为了编辑器匹配 mode
   */
  generateRegExp?(): RegExp;

  /**
   * 匹配 Declaration 中用到的参数值
   * @param input 文本框
   */
  match(input: string): any;
}
